import React, { useState } from "react";
import { Order } from "../../interfaces/order";
import { updateOrderStatus } from "../../services/orderService";

interface CompleteOrderProps {
  order: Order;
  onClose: (message?: string) => void;
}

const CompleteOrder: React.FC<CompleteOrderProps> = ({ order, onClose }) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [loadingSpinner, setLoadingSpinner] = useState(false);

  const handleCompleteOrder = async () => {
    try {
      setLoadingSpinner(true);

      await updateOrderStatus(order.orderID, 4);

      onClose();
    } catch (error) {
      setErrorMessage("Failed to complete the order. Please try again.");
      setLoadingSpinner(false);
    }
  };

  return (
    <>
      <div className="background-mask" onClick={() => onClose()}></div>
      <div className="filter-popup">
        <div className="close-button-container">
          <button className="close-button" onClick={() => onClose()}>
            <i className="bi bi-x-circle"></i>
          </button>
        </div>
        <div className="filter-header">
          <h2>Complete Order</h2>
          <div>Are you sure you would like to complete this order? </div>
          <div>
            After completion no more changes can be made to this order.{" "}
          </div>
        </div>
        <div className="filter-actions">
          <button className="smbtn btn-grey" onClick={() => onClose()}>
            Cancel
          </button>
          <button className={`smbtn btn-green`} onClick={handleCompleteOrder}>
            Complete Order
          </button>
        </div>

        {errorMessage && <div className="error-message">{errorMessage}</div>}
      </div>
      {loadingSpinner && (
        <div className="loading-mask">
          <div className="loading-spinner"></div>
        </div>
      )}
    </>
  );
};

export default CompleteOrder;
